import { Input } from "@/components/ui/input";
import { RefreshCw, Trash2 } from "lucide-react";

const KIND_LABELS = {
  riscaldamento: "Riscaldamento", mobilita: "Mobilità", preparazione: "Preparazione", footwork: "Gambe-scherma",
  tecnica: "Tecnica", tattica: "Tattica", coppia: "Coppia", lezione: "Lezione", assalti: "Assalti", defaticamento: "Defaticamento",
};

export default function BulkProgramPreview({ sessions, setSessions, onRegenerate, busy }) {
  const upd = (i, patch) => setSessions((arr) => { const a = [...arr]; a[i] = { ...a[i], ...patch }; return a; });
  const updBlock = (i, bi, patch) => setSessions((arr) => {
    const a = [...arr]; const bl = [...a[i].blocks]; bl[bi] = { ...bl[bi], ...patch }; a[i] = { ...a[i], blocks: bl }; return a;
  });
  const removeBlock = (i, bi) => setSessions((arr) => { const a = [...arr]; a[i] = { ...a[i], blocks: a[i].blocks.filter((_, k) => k !== bi) }; return a; });
  const kept = sessions.filter((s) => s.keep && !s.existing_id).length;

  return (
    <div className="space-y-2">
      <div className="text-sm text-zinc-600" data-testid="bulk-kept">{kept} sedute selezionate per la creazione</div>
      <div className="space-y-2 max-h-[52vh] overflow-y-auto pr-1">
        {sessions.map((s, i) => (
          <div key={s.dt} data-testid={`bulk-session-${i}`} className={`bg-white border rounded-md p-3 ${s.existing_id ? "border-amber-300 bg-amber-50/40" : s.keep ? "border-zinc-200" : "border-zinc-100 opacity-50"}`}>
            <div className="flex items-start gap-3">
              <input data-testid={`bulk-keep-${i}`} type="checkbox" className="mt-1.5" checked={s.keep && !s.existing_id} disabled={!!s.existing_id} onChange={(e) => upd(i, { keep: e.target.checked })} />
              <div className="flex-1 space-y-1.5">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="font-semibold text-sm" data-testid={`bulk-title-${i}`}>{s.title}</span>
                  <span className="font-mono text-xs text-zinc-500">{s.time} · {s.duration}′</span>
                  {s.existing_id && <span className="text-[10px] uppercase tracking-wider bg-amber-100 text-amber-800 px-2 py-0.5 rounded" data-testid={`bulk-exists-${i}`}>Esiste già · non duplicata</span>}
                  {!s.existing_id && s.blocks.length === 0 && <span className="text-[10px] uppercase tracking-wider bg-zinc-100 text-zinc-500 px-2 py-0.5 rounded">Contenuti da generare</span>}
                  {!s.existing_id && (
                    <div className="ml-auto flex items-center gap-2">
                      <select className="h-7 border border-zinc-200 rounded text-xs px-1" value={s.intensity || "media"} onChange={(e) => upd(i, { intensity: e.target.value })}>
                        <option value="bassa">Bassa</option><option value="media">Media</option><option value="alta">Alta</option>
                      </select>
                      <button data-testid={`bulk-regen-${i}`} disabled={busy} onClick={() => onRegenerate(i)} title="Rigenera solo questa seduta" className="text-zinc-500 hover:text-[#0052FF] disabled:opacity-40"><RefreshCw className="w-3.5 h-3.5" /></button>
                    </div>
                  )}
                </div>
                {!s.existing_id && (
                  <>
                    <Input className="h-8 text-xs" placeholder="Obiettivo della seduta" value={s.objective || ""} onChange={(e) => upd(i, { objective: e.target.value })} />
                    {s.blocks.length > 0 && (
                      <div className="space-y-1 pl-3 border-l-2 border-zinc-100">
                        {s.blocks.map((b, bi) => (
                          <div key={bi} className="flex items-center gap-2 text-xs">
                            <span className="text-[9px] uppercase tracking-wider bg-zinc-100 text-zinc-700 px-1.5 py-0.5 rounded font-mono w-24 text-center">{KIND_LABELS[b.kind] || b.kind}</span>
                            <Input className="h-7 text-xs flex-1" value={b.title} onChange={(e) => updBlock(i, bi, { title: e.target.value })} />
                            <Input type="number" className="h-7 text-xs w-16 font-mono" value={b.duration} onChange={(e) => updBlock(i, bi, { duration: parseInt(e.target.value || 0) })} />
                            <button onClick={() => removeBlock(i, bi)} className="text-zinc-400 hover:text-red-600"><Trash2 className="w-3 h-3" /></button>
                          </div>
                        ))}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
